/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useMemo } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import Model from '@tripian/model';
import { RadioButtonChecked, RadioButtonUnChecked } from '../Svg/Icons/RadioButton';
import SelectBox from '../SelectBox/SelectBox';
import { ChevronDown, ChevronUp } from '../Svg/Icons';
import classes from './SelectBoxTree.scss';

interface ISelectBoxTree {
  domId: string;
  text: string;
  subOptions: Array<Model.SubAnswer>;
  style?: React.CSSProperties;
  checkeds: Array<number>;
  onChangeParent: (checked: boolean, domId: string) => void;
  onChangeChild: (checked: boolean, domId: string) => void;
}

const SelectBoxTree: React.FC<ISelectBoxTree> = ({ domId, text, subOptions, style, checkeds, onChangeParent, onChangeChild }) => {
  const handleCheckboxOnChangeParent = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangeParent(event.target.checked, event.target.name);
  };

  const handleCheckboxOnChangeChild = (checkedChild: boolean, domIdChild: string) => {
    onChangeChild(checkedChild, domIdChild);
  };

  const checkedParent = checkeds.includes(+domId);

  const styles = [classes.checkboxTree];
  if (checkedParent) styles.push(classes.checked);

  const memoizedUniqueDomId = useMemo(() => `checkbox_${domId}_${Math.random()}`, [domId]);

  return (
    <>
      <label className={styles.join(' ')} htmlFor={memoizedUniqueDomId} style={style}>
        <span className={classes.span1}>
          <input id={memoizedUniqueDomId} name={domId} type="checkbox" checked={checkedParent} onChange={handleCheckboxOnChangeParent} />
          {checkedParent ? <RadioButtonChecked size="1.25rem" className={classes.checked} /> : <RadioButtonUnChecked size="1.25rem" />}
        </span>
        <span className={classes.span2}>{text}</span>
        {subOptions.length > 0 && <span className={classes.arrowIcon}>{checkedParent ? <ChevronUp /> : <ChevronDown />}</span>}
      </label>

      {checkedParent && subOptions.length > 0 ? (
        <div className={classes.subOptionsContainer}>
          {subOptions.map((subOption) => (
            <SelectBox key={subOption.id} domId={subOption.id.toString()} text={subOption.name} checked={checkeds.includes(subOption.id)} onChange={handleCheckboxOnChangeChild} />
          ))}
        </div>
      ) : null}
    </>
  );
};

export default SelectBoxTree;
